import React, { useState, useEffect, useRef } from "react";
import { getDocs, collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "./firebase";
import "./AllProducts.css";
import { useLocation } from "react-router-dom";
import { askOpenAI } from "./api/AskOpenAI";

import { useNavigate } from "react-router-dom";
export function superscriptRegistered(text) {
  if (!text) return "";
  return text.replace(/®/g, '<sup style="font-size:0.65em; vertical-align: super;">®</sup>');
}

const productFamilyPriority = [
  "Fiber Cable Assemblies",
  "Fiber Panels",
  "Cassettes",
  "Fiber Terminals & Closures",
  // "Fiber Splice Chassis",
  "Fiber Distribution Frames",
  "Passive Optical Components",
  "Photodetectors",
  "Collimators & Probes",
  "Lenses",
  "Instruments",
  "Services",
];
const hiddenFields = [
  "slug",
  "product",
  "text",
  "datasheet",
  "dataSheet",
  "image",
  "color",
  "features",
  "numChannels",
  "features2",
  "features2Heading",
  "features3",
  "features3Heading",
  "faq",
  "featuresHeading",
  "relatedProducts",
  "featuredContentVideo",
  "featursHeading",
  "image2",
  "image3",
  "image4",
  "image5",
  "image6",
  "image7",
  "image8",
  "image9",
  "installationGuide",
  "installationVideo",
  "introVideo",
  "productSheet",
  "quickInstallationGuide",
  "rank",
  "section1Description",
  "section1Heading",
  "section2Description",
  "section2Heading",
  "specialVideo1",
  "specialVideo1Title",
  "specialVideo2",
  "specialVideo2Title",
  "application",
  "category1Heading",
  "category2Heading",
  "category3Heading",
  "category4Heading",
  "category5Heading",
  "category6Heading",
  "category7Heading",
  "category8Heading",
  "category9Heading",
  "category10Heading",
  "category1Description",
  "category2Description",
  "category3Description",
  "category4Description",
  "category5Description",
  "category6Description",
  "category7Description",
  "category8Description",
  "category9Description",
  "category10Description",
  "installationVideos",
  "frequentlyUsedWith",
  "integration",
  "mounting",
  "section3Description",
  "section3Heading",
  "techNote",
  "whitePaper",
  "brochure",
  "cableTypes"
];

const FilterDropdown = ({ field, options, selectedOptions = [], onChange }) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef();

  const getFilterLabel = (field) => {
    if (field === "beadBaba") return "BEAD/BABA";
    const spaced = field.replace(/([A-Z])/g, " $1").toLowerCase();
    return spaced.charAt(0).toUpperCase() + spaced.slice(1);
  };

  const [dropdownPosition, setDropdownPosition] = useState({});

  useEffect(() => {
    const updatePosition = () => {
      if (!dropdownRef.current) return;
      const rect = dropdownRef.current.getBoundingClientRect();
      setDropdownPosition({
        position: "fixed",
        top: `${rect.bottom}px`,
        left: `${rect.left}px`,
        zIndex: 9999,
      });
    };

    updatePosition();
    window.addEventListener("resize", updatePosition);
    window.addEventListener("scroll", updatePosition, true); // `true` to catch scroll in scrollable containers

    return () => {
      window.removeEventListener("resize", updatePosition);
      window.removeEventListener("scroll", updatePosition, true);
    };
  }, [open]);

  const allSelected = options.length > 0 && options.every((opt) => selectedOptions.includes(opt));
  const isActive = selectedOptions.length > 0;

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const toggleAll = () => {
    onChange(field, allSelected ? "__clear_all__" : "__select_all__", options);
  };

  return (
    <div className="filter-dropdown" ref={dropdownRef}>
      <button className={`filter-dropdown-toggle ${isActive ? "active" : ""}`} onClick={() => setOpen((prev) => !prev)}>
        {getFilterLabel(field)} {isActive ? `(${selectedOptions.length})` : ""}
      </button>
      {open && (
        <div className="filter-dropdown-menu" style={dropdownPosition}>
          <div className="filter-dropdown-controls">
            <button onClick={toggleAll} className="filter-select-all-btn">
              {allSelected ? "Clear All" : "Select All"}
            </button>
          </div>
          {options.map((opt, i) => (
            <label key={i} className="filter-dropdown-option">
              <input type="checkbox" checked={selectedOptions.includes(opt)} onChange={() => onChange(field, opt)} />
              {typeof opt === "boolean" ? String(opt) : opt}
            </label>
          ))}
        </div>
      )}
    </div>
  );
};

const AllProducts = () => {
  const [allProducts, setAllProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [filters, setFilters] = useState({});
  const [search, setSearch] = useState("");
  const [availableFilters, setAvailableFilters] = useState({});

  const [showChat, setShowChat] = useState(false);
  const [userPrompt, setUserPrompt] = useState("");
  const [chatHistory, setChatHistory] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [inputMessage, setInputMessage] = useState("");
  const [chatMessages, setChatMessages] = useState([]);

  const [reply, setReply] = useState("");

  // const handleSendAPI = async () => {
  //   const result = await askOpenAI([{ role: "user", content: input }]);
  //   setReply(result);
  // };

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const fetchProducts = async () => {
      const snap = await getDocs(collection(db, "products"));
      const products = snap.docs.map((doc) => doc.data());

      const sortedProducts = [...products]
        .filter((p) => p.productFamily && p.rank)
        .sort((a, b) => {
          const rankA = parseInt(a.rank) || 9999;
          const rankB = parseInt(b.rank) || 9999;

          if (rankA !== rankB) return rankA - rankB;

          const priorityA = productFamilyPriority.indexOf(a.productFamily);
          const priorityB = productFamilyPriority.indexOf(b.productFamily);

          return priorityA - priorityB;
        });

      // save sorted results
      setAllProducts(sortedProducts);
      setFilteredProducts(sortedProducts);

      // 🔧 Dynamic filter fields
      const fieldOptions = {};

      products.forEach((p) => {
        Object.entries(p).forEach(([key, val]) => {
          if (hiddenFields.includes(key)) return;
          if (!val || (Array.isArray(val) && val.length === 0)) return;
          if (typeof val === "object" && !Array.isArray(val)) return;

          const values = Array.isArray(val) ? val : [val];
          if (!fieldOptions[key]) fieldOptions[key] = new Set();
          values.forEach((v) => fieldOptions[key].add(v));
        });
      });

      const result = {};
      Object.entries(fieldOptions).forEach(([k, v]) => {
        result[k] = Array.from(v).sort();
      });

      setAvailableFilters(result);
    };

    fetchProducts();
  }, [location.pathname]);

  useEffect(() => {
    let results = [...allProducts];

    if (search.trim()) {
      results = results.filter((p) =>
        Object.values(p).some((val) => typeof val === "string" && val.toLowerCase().includes(search.toLowerCase()))
      );
    }

    // Apply filters
    Object.entries(filters).forEach(([field, selected]) => {
      if (!selected.length) return;
      results = results.filter((p) => {
        const val = p[field];
        if (Array.isArray(val)) return selected.some((s) => val.includes(s));
        return selected.includes(val);
      });
    });

    setFilteredProducts(
      results.sort((a, b) => {
        const hasImageA = a.image && a.image.trim() !== "";
        const hasImageB = b.image && b.image.trim() !== "";
        return hasImageB - hasImageA; // puts "no image" products at bottom
      })
    );

    // Update visible filter options based on current results
    const fieldOptions = {};

    results.forEach((p) => {
      Object.entries(p).forEach(([key, val]) => {
        if (hiddenFields.includes(key)) return;
        if (!val || (Array.isArray(val) && val.length === 0)) return;
        if (typeof val === "object" && !Array.isArray(val)) return;

        const values = Array.isArray(val) ? val : [val];
        if (!fieldOptions[key]) fieldOptions[key] = new Set();
        values.forEach((v) => fieldOptions[key].add(v));
      });
    });

    const newFilterOptions = {};
    Object.entries(fieldOptions).forEach(([k, v]) => {
      newFilterOptions[k] = Array.from(v).sort();
    });
    setAvailableFilters(newFilterOptions);

    // Unselect invalid filters
    // setFilters(prev => {
    //   const updated = { ...prev };
    //   Object.keys(prev).forEach(field => {
    //     const validOptions = newFilterOptions[field] || [];
    //     updated[field] = prev[field].filter(v => validOptions.includes(v));
    //     if (updated[field].length === 0) delete updated[field]; // Remove empty filters
    //   });
    //   return updated;
    // });
  }, [filters, search, allProducts]);

  //I’m designing a high-speed fiber optic transceiver for a telecom application and need components that support 100G+ data rates with minimal insertion loss.

  const handleSend = async () => {
    if (!inputMessage.trim()) return;

    const userMessage = inputMessage.trim(); // keep a local copy

    const prompt = `
You are a helpful AI assistant for Go!Foton, a US-based fiber optics and photonics company.

GENERAL RULES:
- Respond in clear, professional language.
- Do NOT use headings, markup, bullet symbols, or decorative separators.
- Respond in one concise paragraph unless the question clearly requires more.
- If the user asks about company information, use ONLY the company information below.
- If the user asks about a project or product, follow the PRODUCT RECOMMENDATION RULES below.

=====================
COMPANY INFORMATION
=====================

Go!Foton is a US-based innovator in optics and photonics with global operations in the USA, Japan, Philippines, China, and the Netherlands. The company designs and manufactures advanced optical and photonic solutions that solve real-world problems in connectivity, imaging, medical, biotech, defense, and telecommunications.

Go!Foton’s mission is to drive customer value through innovations inspired by nature and science. With over 100 years of combined optical and photonics expertise, the company delivers feature-rich, performance-optimized solutions with an emphasis on quality, scalability, and customization.

Go!Foton is BEAD and BABA compliant where applicable, offers US-based manufacturing options, and is trusted by Tier 1 customers. The company is known for original designs, strong intellectual property, agile manufacturing from prototype through volume, and certifications including Verizon and Telcordia.

Founded in 2009 following a management buyout of NSG’s telecom device business, Go!Foton’s heritage traces back to major milestones such as the invention of GRIN lenses, the SELFOC® microlens platform, and modern high-density fiber management systems like PEACOC®.

Today, Go!Foton is a leading provider of photonics and optical communication technologies, supporting customers from concept and design through deployment and long-term support.

=====================
PRODUCT RECOMMENDATION RULES
=====================

The customer is working on a project and provided this message:

"${userMessage}"

Here is the list of available products:
${allProducts.map((p) => `- ${p.product}: ${p.text || "No description"}`).join("\n")}

Based on the customer’s message:
- Recommend the most relevant product or products from the list.
- You may recommend up to three products if appropriate.
- Each recommended product MUST appear in its own set of brackets.
- Place the bracketed product names at the END of your response.
- Format example: [Product A], [Product B]
- Do NOT use empty brackets or comma-only brackets.
`.trim();

    setChatMessages((prev) => [...prev, { role: "user", content: userMessage }]);
    setInputMessage("");
    setIsLoading(true);

    try {
      const reply = await askOpenAI([{ role: "user", content: prompt }]);

      // extract [Product] tokens
      const matchedProducts = reply.match(/\[(.*?)\]/g)?.map((str) => str.replace(/[\[\]]/g, "").trim()) || [];

      const matchedThumbnails = allProducts.filter((p) => matchedProducts.includes(p.product));

      // update UI
      setChatMessages((prev) => [...prev, { role: "assistant", content: reply, products: matchedThumbnails }]);

      // 🔥 log this exchange in Firestore as a new document
      await addDoc(collection(db, "aiChats"), {
        userMessage,
        assistantReply: reply,
        matchedProducts, // product names (strings)
        matchedProductIds: matchedThumbnails.map((p) => p.slug || p.id || p.product),
        createdAt: serverTimestamp(),
      });
    } catch (e) {
      console.error("handleSend fail:", e);
      setChatMessages((prev) => [
        ...prev,
        { role: "assistant", content: `Error contacting AI assistant: ${e.message}` },
      ]);

      // optional: log errors as well
      await addDoc(collection(db, "aiChatErrors"), {
        userMessage,
        error: e.message,
        createdAt: serverTimestamp(),
      });
    } finally {
      setIsLoading(false);
    }
  };

  const filterScrollRef = useRef();

  const scrollFilters = (amount) => {
    if (filterScrollRef.current) {
      filterScrollRef.current.scrollBy({ left: amount, behavior: "smooth" });
    }
  };

  const handleFilterChange = (field, value, allOptions = []) => {
    setFilters((prev) => {
      if (value === "__select_all__") {
        return { ...prev, [field]: allOptions };
      }
      if (value === "__clear_all__") {
        return { ...prev, [field]: [] };
      }

      const current = prev[field] || [];
      const updated = current.includes(value) ? current.filter((v) => v !== value) : [...current, value];
      return { ...prev, [field]: updated };
    });
  };

  return (
    <div className="all-products-page">
      <div className="filter-bar">
        {/* Fixed search input stays outside scroll */}
        <div className="search-wrapper">
          <input
            className="search-input"
            placeholder="Search products..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          {search && (
            <span className="clear-search" onClick={() => setSearch("")}>
              ×
            </span>
          )}
        </div>

        {/* Scrollable filters area with chevrons */}
        <div className="filter-scroll-wrapper">
          <button className="scroll-btn left" onClick={() => scrollFilters(-200)}>
            ‹
          </button>

          <div className="filter-controls" ref={filterScrollRef}>
            {Object.entries(availableFilters)
              .sort(([a], [b]) => {
                if (a === "productFamily") return -2;
                if (b === "productFamily") return 2;
                if (a === "subFamily") return -1;
                if (b === "subFamily") return 1;
                return a.localeCompare(b);
              })
              .map(([field, options]) => {
                if (!options || options.length === 0) return null;

                return (
                  <FilterDropdown
                    key={field}
                    field={field}
                    options={options}
                    selectedOptions={filters[field] || []}
                    onChange={handleFilterChange}
                  />
                );
              })}
          </div>

          <button className="scroll-btn right" onClick={() => scrollFilters(200)}>
            ›
          </button>

          {Object.values(filters).some((arr) => arr.length > 0) && (
            <button className="clear-filters-btn" onClick={() => setFilters({})}>
              Clear All Filters ✕
            </button>
          )}
        </div>
      </div>

      <div className="product-grid">
        {filteredProducts.map((p, idx) => (
          <div key={idx} className="product-card" onClick={() => navigate(`/${p.slug}`)} style={{ cursor: "pointer" }}>
            <img
              src={
                p.image && p.image.trim() !== ""
                  ? p.image
                  : "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/icons%2FGoFoton%20Placeholder.jpg?alt=media&token=94562a2e-50b7-4b8a-af28-381fd3bef222"
              }
              alt={p.product || "No Image"}
              style={{
                width: "100%",
                height: 150,
                objectFit: p.product === "CORE Kit" ? "contain" : "cover",
                backgroundColor: "#f3f3f3",
              }}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src =
                  "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/icons%2FGoFoton%20Placeholder.jpg?alt=media&token=94562a2e-50b7-4b8a-af28-381fd3bef222";
              }}
            />

            <h3 dangerouslySetInnerHTML={{ __html: superscriptRegistered(p.product) }} />

            <p>
              <strong>{p.productFamily}</strong>
            </p>

            {p.text && <p>{p.text.length > 150 ? p.text.slice(0, 150) + "..." : p.text}</p>}

            {Object.entries(filters).map(([field]) => {
              const value = p[field];
              if (value === undefined || value === null) return null;

              // Convert camelCase to sentence case (except beadBaba special)
              const label =
                field === "beadBaba"
                  ? "BEAD/BABA"
                  : field
                      .replace(/([A-Z])/g, " $1")
                      .toLowerCase()
                      .replace(/^./, (s) => s.toUpperCase());

              return (
                <p key={field}>
                  <strong>{label}:</strong> {Array.isArray(value) ? value.join(", ") : String(value)}
                </p>
              );
            })}
          </div>
        ))}
      </div>
      <div className="product-count">
        Showing {filteredProducts.length} of {allProducts.length} products
      </div>

      {showChat && (
        <div className="chat-widget">
          <div className="chat-header">
            <span>Pluma • Go!Foton's AI Assistant</span>
            <button onClick={() => setShowChat(false)} className="chat-close">
              ×
            </button>
          </div>

          <div className="chat-messages">
            {chatMessages.map((msg, i) => (
              <div key={i} className={msg.role === "user" ? "user-msg" : "ai-msg"}>
                <p>{msg.content}</p>

                {msg.role === "assistant" && msg.products && msg.products.length > 0 && (
                  <div className="chat-thumbnails">
                    {msg.products.map((p, idx) => (
                      <div key={idx} className="thumbnail-card" onClick={() => navigate(`/${p.slug}`)}>
                        <img
                          src={
                            p.image && p.image.trim() !== ""
                              ? p.image
                              : "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/icons%2FGoFoton%20Placeholder.jpg?alt=media&token=94562a2e-50b7-4b8a-af28-381fd3bef222"
                          }
                          alt={p.product}
                          style={{ width: "100%", height: 100, objectFit: "contain", backgroundColor: "#fff" }}
                        />
                        <div className="thumb-text">
                          <strong>{p.product}</strong>
                          <p>{p.productFamily}</p>
                          <p>{p.text ? (p.text.length > 50 ? p.text.slice(0, 50) + "..." : p.text) : ""}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}

            {isLoading && <div className="ai-msg">Typing...</div>}
          </div>

          <form
            className="chat-input"
            onSubmit={(e) => {
              e.preventDefault();
              handleSend();
            }}
          >
            <textarea
              value={inputMessage}
              onChange={(e) => setInputMessage(e.target.value)}
              placeholder="Describe your project..."
              rows={2}
              style={{
                resize: "none",
                overflow: "auto",
                width: "100%",
                padding: "8px",
                borderRadius: "4px",
                fontSize: "14px",
                fontFamily: "inherit",
                lineHeight: "1.4",
              }}
            />
            <button type="submit">Send</button>
          </form>
        </div>
      )}

      <button className="chat-launcher" onClick={() => setShowChat(true)}>
        💬
      </button>
    </div>
  );
};

export default AllProducts;
